export default "__VITE_ASSET__CVMQgxb$__"